module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/YoojoWallet-a3dfae8f15e02ea7ca0ff521632ee022.svg";